module.exports = __webpack_public_path__ + "img/Pirate-Ship-Tattoo-88-765x956.jpg";